import { fontGrid } from "@mui/material/styles/cssUtils";
import { getLocalStorage } from "./browserStorage";

export const apiUrl = process.env.REACT_APP_API_URL;
export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

export function checkAuth() {
  return getLocalStorage("accessToken");
}

export const validatePassword = (value) => {
  return (
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm.test(value) ||
    "Password must contain at least 8 characters, including uppercase, lowercase, and numbers"
  );
};

export function validateEmail(email) {
  const emailRegex = /^\S+@\S+$/;
  return emailRegex.test(email);
}

export function getImageUrl(url) {
  if (!url) {
    return;
  }

  return backendUrl + url;
}

export function getfrontendUrl() {
  return frontendUrl;
}

export function getDefaultAction() {
  return { type: "", isOpen: false, data: null };
}
